// extracted by mini-css-extract-plugin
export default {"defaultLayoutContainer":"layouts_defaultLayoutContainer__D2rj6"};